import $ from 'jquery';
import 'slick-carousel';

const MapSlider = () => {

	let mapSlider = $('#mapslider');

	mapSlider.slick({
		accessibility: false,
		arrows: false,
		adaptiveHeight: false,
		dots: false,
		draggable: false,
		fade: true,
		infinite: false,
		mouseDrag: false,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	const map_select = document.querySelector('#mapselect');

	if (typeof map_select != "undefined" && map_select != null) {
		
		map_select.addEventListener( 'change', () => {

			if (typeof map_select.value != "undefined" && map_select.value != null) {
				selectSlide(map_select.value);
			}

		});
	}

	const map_buttons = document.querySelectorAll('[data-button]');

	Array.from(map_buttons).forEach(map_button => {

		if (typeof map_button != "undefined" && map_button != null) {

			map_button.addEventListener( 'click', (e) => {

				e.preventDefault();
				map_select.value = map_button.getAttribute('data-button');
				mapSlider.slick('slickGoTo', 1);

				Array.from(map_elements).forEach(all_elements => {
					all_elements.classList.remove('is-current', 'is-hover');
				});
			});
		}
	});

	var map_elements = document.querySelectorAll('.funding-map path, .funding-map polygon');

	Array.from(map_elements).forEach(map_element => {

		map_element.classList.remove('is-current', 'is-hover');
			
		map_element.addEventListener('mouseenter', () => {
		
			let map_id = map_element.id;

			Array.from(map_elements).forEach(other_elements => {
				other_elements.classList.remove('is-hover');
			});

			if (typeof map_id != "undefined" && map_id != null) {

				let map_info = checkSlide(map_id);

				if (typeof map_info != "undefined" && map_info != null) {
					map_element.classList.add('is-hover');
				}
			}
		});

		map_element.addEventListener('mouseleave', () => {
			map_element.classList.remove('is-hover');
		});

		map_element.addEventListener('click', () => {

			let map_id = map_element.id;

			if (typeof map_id != "undefined" && map_id != null) {

				Array.from(map_elements).forEach(other_elements => {
					other_elements.classList.remove('is-current');
				});

				map_element.classList.add('is-current');
				selectSlide(map_id, map_element);
			}

		});
	});

	function selectSlide(map_id) {

		let map_stats = checkSlide(map_id);

		if (typeof map_stats != "undefined" && map_stats != null) {

			let active_slide = map_stats.getAttribute('data-slideid');
				
			if (typeof active_slide != "undefined" && active_slide != null) {
				mapSlider.slick('slickGoTo', active_slide);
			} else {
				goToZero();
			}
		} else {
			goToZero();
		}
	}

	function checkSlide(slide) {
		
		let map_stats = document.querySelectorAll(`[data-map="${slide}"]`);

		if (typeof map_stats != "undefined" && map_stats != null) {

			if (typeof map_stats[0] != "undefined" && map_stats[0] != null) {
				return map_stats[0];
			}

			return null;
		}

		return null;
	}

	function goToZero() {
		mapSlider.slick('slickGoTo', 0);

		Array.from(map_elements).forEach(all_elements => {
			all_elements.classList.remove('is-current', 'is-hover');
		});
	}
};

export default MapSlider;